/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_JoinInputs */

const en_us2_clubs_join = /** @type {(inputs: Clubs_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Join with a code`)
};

const pt_br2_clubs_join = /** @type {(inputs: Clubs_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrar com código`)
};

const es_419_clubs_join = /** @type {(inputs: Clubs_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unirme con código`)
};

const pt_pt2_clubs_join = /** @type {(inputs: Clubs_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrar com código`)
};

const fr_fr2_clubs_join = /** @type {(inputs: Clubs_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rejoindre avec un code`)
};

const de_de2_clubs_join = /** @type {(inputs: Clubs_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mit Code beitreten`)
};

const it_it2_clubs_join = /** @type {(inputs: Clubs_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entra con un codice`)
};

/**
* | output |
* | --- |
* | "Join with a code" |
*
* @param {Clubs_JoinInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_join = /** @type {((inputs?: Clubs_JoinInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_JoinInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_join(inputs)
	if (locale === "es-419") return es_419_clubs_join(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_join(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_join(inputs)
	if (locale === "de-DE") return de_de2_clubs_join(inputs)
	if (locale === "it-IT") return it_it2_clubs_join(inputs)
	return en_us2_clubs_join(inputs)
});
export { clubs_join as "clubs.join" }